import React, { Component } from 'react';
import { withRouter, Route } from 'react-router';
import { Label, Message, TextArea, Statistic, Step, Dropdown, Menu, Tab, Header, Dimmer, Loader, Table, Grid, Form, Input, Segment, Button, Icon } from 'semantic-ui-react';
import {
    isEmpty,
    isDefined,
    mascaraData,
    decimalFormat,
    tipoFreteOptions,
    parseDecimal,
    mascaraCep,
    estadoOptions
} from '../../util/Common';
import * as LocalStorageManager from '../../util/StorageManager';
import HttpService from '../../util/HttpService';
import _ from 'lodash';
import Moment from 'moment';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import ModalProdutos from './ModalProdutos';
import DetalheOrcamento from './DetalheOrcamento';
import ButtonLink from '../../components/ButtonLink';
import ConfirmSave from '../../components/ConfirmSave';
import { If } from '../../components/ConditionalRendering';

import 'react-datepicker/dist/react-datepicker.css';

class OrcamentoVenda extends Component {

    constructor(){
        super();
        this.state = {
			codigo: '',
			nota: '',
			cliente: [],
			dataInicial: new Moment(),
			dataFinal: new Moment(),
			orcamento: {
                controle: '',
                dataPedido: new Moment(),
                clienteId: LocalStorageManager.getLoggedUser().isCliente ? LocalStorageManager.getLoggedUser().idt : '',
                vendedorId: LocalStorageManager.getLoggedUser().isCliente ? '' : LocalStorageManager.getLoggedUser().idt,
                formaPagamentoId: '',
                supervisorId: '',
                quantidadeItens: 0,
                valorTotal: '',
                tipoFrete: 'AP',
                valorFrete: '',
                distancia: '',
                cep: '',
                endereco: '',
                numeroEndereco: '',
                complemento: '',
                bairro: '',
                cidade: '',
                codigoCidade: '',
                estado: '',
                dataEntrega: new Moment(),
                observacoes: '',
                produtos: [],
                editado: false
			},
			clientes: undefined,
			supervisores: undefined,
			formasPagamento: undefined,
            cidades: undefined,
			orcamentos: undefined,
			activeIndex: 1,
			activeStep: 'pedido',
			senhaConfirmacao: '',
			confirmarSalvar: false,
			isLoadingCep: false,
			isLoading: false
        }
	}

	componentDidMount(){
		if(LocalStorageManager.getLoggedUser().isCliente){
			// Aqui o idt de LoggedUser eh o idt de um cliente
			this.buscarFormasPagamento(LocalStorageManager.getLoggedUser().idt);
		}else{
			this.buscarSupervisores();
		}
		
		this.buscarClientes();
		this.buscarOrcamentos();
	}
	
	novoOrcamento = () => {
		const { formasPagamento } = this.state;

		this.setState({ 
			activeStep: 'pedido', 
			formasPagamento: LocalStorageManager.getLoggedUser().isCliente ? formasPagamento : [],
			orcamento: {
                controle: '', 
				dataPedido: new Moment(), 
				clienteId: LocalStorageManager.getLoggedUser().isCliente ? LocalStorageManager.getLoggedUser().idt : '',
				vendedorId: LocalStorageManager.getLoggedUser().isCliente ? '' : LocalStorageManager.getLoggedUser().idt,
				formaPagamentoId: isDefined(formasPagamento) && formasPagamento.length === 1 ? formasPagamento[0].value : '',
				supervisorId: '',
				quantidadeItens: 0,
				valorTotal: '',
				tipoFrete: 'AP', 
				valorFrete: '',
				distancia: '',
				cep: '',
				endereco: '',
				numeroEndereco: '',
                complemento: '',
				bairro: '',
				cidade: '',
                codigoCidade: '',
				estado: '',
				dataEntrega: new Moment(), 
				observacoes: '',
				produtos: [],
				editado: false
			}
		});
	}

	buscarClientes = () => {
		const user = LocalStorageManager.getLoggedUser();

		if(user.isCliente){
			// Seta o cliente selecionado como o proprio cliente logado
			this.setState({ cliente: [user.idt] });
		}else{
			HttpService.call(
				'sistema/combos',
				'clientes',
				[
					// idt do vendedor
					user.idt
				],
				(clientes) => this.setState({ clientes })
			);
		}
	}

	buscarSupervisores = () => {
		HttpService.call(
            'sistema/combos',
			'supervisores',
			[],
			(supervisores) => this.setState({ supervisores })
        );
	}

	buscarFormasPagamento = (idtCliente) => {
		HttpService.call(
            'sistema/combos',
			'formasPagamento',
			[
				idtCliente
			],
			(formasPagamento) => this.setState({ formasPagamento })
        );
	}

    buscarCidades = (uf) => {
        this.setState({ cidades: undefined });

        HttpService.call(
            'sistema/combos',
            'cidades',
            [
                uf
            ],
            (cidades) => this.setState({ cidades })
        );
    }

	buscarOrcamentos = () => {
		const { codigo, nota, cliente, dataInicial, dataFinal } = this.state;
		const user = LocalStorageManager.getLoggedUser();

		this.setState({ isLoading: true });

		HttpService.call(
            'cadastro/orcamentoVenda',
			'buscarPedidos',
			[
				codigo,
				nota,
				user.isCliente ? [ user.idt ] : cliente, // Se for cliente, utiliza o proprio idt do cliente como parametro
				dataInicial.format('YYYYMMDD'),
				dataFinal.format('YYYYMMDD'),
				LocalStorageManager.getOrigem().idt,
				'S', // isOrcamento = 'S', sao os pedidos em aberto (orcamentos).
				!user.isCliente ? user.idt : '' // idt do vendedor, caso nao seja cliente.
			],
			(orcamentos) => this.setState({ orcamentos, isLoading: false })
        );
	}

	atualizarEndereco = (endereco) => {
		if (!isDefined(endereco)){
			toast.error(<div><p>Erro ao buscar CEP!</p> O serviço pode estar temporariamente indisponível.</div>);
		} else if (endereco.erro){
			toast.warn(endereco.mensagem);
		} else {
		    this.buscarCidades(endereco.estado);

			this.setState({ orcamento: {
					...this.state.orcamento,
					...endereco
				} 
			});
		}
		
		this.setState({ isLoadingCep: false });
	}

	salvarOrcamento = (finishLoading) => {
		const { orcamento, confirmarSalvar, clientes, senhaConfirmacao } = this.state;

		// Testa se foi selecionada uma forma de pagamento e que ainda nao foi confirmada
		if(orcamento.formaPagamentoId !== '' && !confirmarSalvar){
			this.setState({ confirmarSalvar: true, senhaConfirmacao: '' });
		}else{
			const user = LocalStorageManager.getLoggedUser();
			// eslint-disable-next-line
			const nomeCliente = user.isCliente ? user.nome : _.find(clientes, (item) => item.value == orcamento.clienteId).text;

            this.setState({ isLoading: true });

			HttpService.call(
				'cadastro/orcamentoVenda',
				'salvarOrcamento',
				[
					{
						...orcamento,
                        formaPagamentoId: orcamento.formaPagamentoId !== '' ? orcamento.formaPagamentoId : null,
						dataPedido: orcamento.dataPedido.format('YYYYMMDD'),
						dataEntrega: orcamento.dataEntrega.format('YYYYMMDD'),
						origem: LocalStorageManager.getOrigem().idt,
						nomeCliente
					},
					{
						autenticar: orcamento.formaPagamentoId !== '',
						tipoLogin: user.isCliente ? 'cliente' : 'representante',
						documento: user.documento,
						senha: senhaConfirmacao
					}
				],
				(retorno) => {
					if(isDefined(retorno)){
						if(retorno.result){
							this.setState({ confirmarSalvar: false, activeIndex: 1 });
							toast.success('Orçamento salvo com sucesso!');
							this.buscarOrcamentos();
						}else if(isDefined(retorno.mensagem)){
							toast.error('Senha de confirmação incorreta!');
						}
					}else{
						toast.error('Erro ao salvar orçamento.');
					}

					this.setState({ senhaConfirmacao: '', isLoading: false });

                    if(isDefined(finishLoading)){
                        // Executa funcao que pode vir por parametro, nesse caso serve
                        // para quando a funcao de salvar eh chamada na tela de
                        // confirmacao, eh passado uma funcao para parar o 'loading'
                        // do botao de salvar.
                        finishLoading();
                    }
				}
			);
		}
	}

    handleTabChange = (e, { activeIndex }) => {
		this.setState({ activeIndex });
		
		switch(activeIndex){
			case 0:
				this.buscarClientes();
				this.novoOrcamento();
				break;
			case 1:
				this.buscarOrcamentos();
				break;
			default:
		}
	}
	
	handleStepChange = (e, { name }) => this.setState({ activeStep: name });

	handleChangeOrcamento = (e, { name, value }) => {
		let orcamento;
		
		switch(name){
			case 'clienteId':
				orcamento = {
					[name]: value,
					produtos: [],
					valorTotal: 0,
					quantidadeItens: 0
				}

				if(!LocalStorageManager.getLoggedUser().isCliente){
					this.buscarFormasPagamento(value);
				}
				break;
			case 'cep':
				value = mascaraCep(value);

				if(value.length === 9){
					this.setState({ isLoadingCep: true });

					HttpService.call(
						'cadastro/orcamentoVenda',
						'buscarEnderecoCep',
						[
							value,
							LocalStorageManager.getOrigem().idt
						],
						this.atualizarEndereco
					)
				}

				orcamento = {
					[name]: value
				}
				break;
            case 'tipoFrete':
                let valorFrete = this.state.orcamento.valorFrete;

                // Se o frete for do tipo "Frete à pagar", zera o Valor do Frete e bloqueia o campo
                if(value === 'AP'){
                    valorFrete = '';
                }

                orcamento = {
                    [name]: value,
                    valorFrete
                }
                break;
			case 'valorFrete':
                orcamento = {
                    [name]: decimalFormat(value, 2)
                }
				break;
            case 'estado':
                this.buscarCidades(value);

                orcamento = {
                    [name]: value,
                    codigoCidade: '',
                    cidade: ''
                }
                break;
            case 'codigoCidade':
                orcamento = {
                    [name]: value,
                    cidade: _.find(this.state.cidades, c => c.value === value).text
                }
                break;
			case 'produtos':
				orcamento = { 
					[name]: value,
					valorTotal: _.sum(_.map(value, p => parseDecimal(p.valorTotal, 2))).toFixed(2),
					quantidadeItens: value.length
				}
				break;
			default:
				orcamento = { 
					[name]: value
				}
		}

		orcamento.editado = true;
		this.setState({ orcamento: { 
			...this.state.orcamento, 
			...orcamento 
		} });
	}

    render() {
		const { activeStep, codigo, cliente, dataInicial, dataFinal, nota, orcamento, orcamentos, formasPagamento, clientes, supervisores, cidades, confirmarSalvar, senhaConfirmacao, activeIndex, isLoadingCep, isLoading } = this.state;
		const camposObrigatoriosPreenchidos = isDefined(orcamento.dataPedido) && (LocalStorageManager.getLoggedUser().isCliente || orcamento.clienteId !== '');

        const panes = [
            { 
                menuItem: <Menu.Item key='novo'>
                            <Icon name='plus' color='green'/>
                            Novo orçamento
                        </Menu.Item>, 
                render: () => (
					<Tab.Pane attached={false} className='no-pad-tab'>
						<Step.Group attached='top'>
							<Step active={activeStep === 'pedido'} name='pedido' link icon='info' title='Pedido' description='Dados principais' onClick={this.handleStepChange} />
							<Step active={activeStep === 'frete'} name='frete' link icon='truck' title='Frete' description='Dados da entrega' onClick={this.handleStepChange} />
							<Step active={activeStep === 'produtos'} name='produtos' link icon='tags' title='Produtos' onClick={this.handleStepChange} />
						</Step.Group>
						<If test={activeStep === 'pedido'}>
							<Segment attached>
								<Form size='small' className='clearing'>
									<Form.Group>
										<Form.Field width={4} control={DatePicker} label='Data' required selected={orcamento.dataPedido} minDate={new Moment()} onChange={(data) => this.handleChangeOrcamento(null, { name: 'data', value: data })} onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
										<Form.Field width={4} control={Input} label='Controle' name='controle' value={orcamento.controle} onChange={this.handleChangeOrcamento} />
									</Form.Group>
									<If test={!LocalStorageManager.getLoggedUser().isCliente}>
										<Form.Group widths='equal'>
											<Form.Field control={Dropdown} label='Cliente' name='clienteId'
														fluid search selection required selectOnBlur={false}
														noResultsMessage='Nenhum resultado encontrado' 
														value={orcamento.clienteId}
														options={clientes}
														loading={clientes === undefined}
														onChange={this.handleChangeOrcamento}/>
											<Form.Field control={Dropdown} label='Supervisor' name='supervisorId'
														fluid search selection selectOnBlur={false}
														noResultsMessage='Nenhum resultado encontrado' 
														value={orcamento.supervisorId}
														options={supervisores}
														loading={supervisores === undefined}
														onChange={this.handleChangeOrcamento}/>
										</Form.Group>
									</If>
									<Form.Field>
										<label>Forma de pagamento</label>
										<Dropdown fluid search selection selectOnBlur={false}
												name='formaPagamentoId'
												noResultsMessage='Nenhum resultado encontrado'
												disabled={orcamento.clienteId === ''} 
												value={orcamento.formaPagamentoId}
												options={formasPagamento}
												loading={formasPagamento === undefined}
												onChange={this.handleChangeOrcamento}/>
									</Form.Field>
									<Form.Field control={TextArea} label='Observações' name='observacoes' value={orcamento.observacoes} onChange={this.handleChangeOrcamento} />
								</Form>
							</Segment>
						</If>
						<If test={activeStep === 'frete'}>
							<Segment attached>
								<Form size='small' className='clearing'>
									<Form.Group widths='4'>
										<Form.Field control={Dropdown} label='Tipo de frete' name='tipoFrete'
													fluid selection 
													value={orcamento.tipoFrete}
													options={tipoFreteOptions} 
													onChange={this.handleChangeOrcamento}/>
                                        <Form.Field control={Input} label='CEP' placeholder='Ex.: 80620-100' name='cep' value={orcamento.cep} loading={isLoadingCep} onChange={this.handleChangeOrcamento} />
                                        <If test={!LocalStorageManager.getLoggedUser().isCliente}>
                                            <Form.Field>
                                                <label>Valor Frete (R$)</label>
                                                <Input disabled={orcamento.tipoFrete === 'AP'} placeholder='Ex.: 100,00' className='text-align-right' name='valorFrete' value={orcamento.valorFrete} onChange={this.handleChangeOrcamento} />
                                            </Form.Field>
                                            <Form.Field control={DatePicker} label='Data entrega' name='dataEntrega' selected={orcamento.dataEntrega} minDate={new Moment()} onChange={(dataEntrega) => this.handleChangeOrcamento(null, { name: 'dataEntrega', value: dataEntrega })} onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
                                        </If>
									</Form.Group>
									<Form.Group>
										<Form.Field width={8} control={Input} label='Endereço' placeholder='Ex.: Rua Santa Catarina' name='endereco' value={orcamento.endereco} onChange={this.handleChangeOrcamento} />
										<Form.Field width={2} control={Input} label='Número' placeholder='Ex.: 65' name='numeroEndereco' value={orcamento.numeroEndereco} onChange={this.handleChangeOrcamento} />
                                        <Form.Field width={4} control={Input} label='Complemento' placeholder='Ex.: Ap. 705 Bloco B' name='complemento' value={orcamento.complemento} onChange={this.handleChangeOrcamento} />
									</Form.Group>
									<Form.Group widths='4'>
										<Form.Field control={Input} label='Bairro' placeholder='Ex.: Água Verde' name='bairro' value={orcamento.bairro} onChange={this.handleChangeOrcamento} />
										<Form.Field control={Dropdown} label='Estado' name='estado'
                                                    noResultsMessage='Nenhum resultado encontrado'
                                                    placeholder='Selecione um estado'
													selectOnNavigation={false}
													selectOnBlur={false}
													fluid selection search
													value={orcamento.estado}
													options={estadoOptions}
													onChange={this.handleChangeOrcamento}/>
                                        <Form.Field>
                                            <label>Cidade</label>
                                            <Dropdown fluid selection search name='codigoCidade'
                                                      noResultsMessage='Nenhum resultado encontrado'
                                                      placeholder='Selecione uma cidade'
                                                      loading={!isEmpty(orcamento.estado) && !isDefined(cidades)}
                                                      disabled={isEmpty(orcamento.estado) && !isDefined(cidades)}
                                                      selectOnNavigation={false}
                                                      selectOnBlur={false}
                                                      value={orcamento.codigoCidade}
                                                      options={cidades}
                                                      onChange={this.handleChangeOrcamento}/>
                                        </Form.Field>
									</Form.Group>
                                    <Header subheader={orcamento.distancia}/>
								</Form>
							</Segment>
						</If>
						<If test={activeStep === 'produtos'}>
							<If test={!camposObrigatoriosPreenchidos}>
								<Segment attached secondary clearing>
									<Message warning icon>
										<Icon name='warning circle'/>
										<Message.Content>
											<Message.Header>
												Preencha a data e cliente do pedido.
											</Message.Header>
											Para continuar  <ButtonLink onClick={() => this.setState({ activeStep: 'pedido' })} text='clique aqui.' />
										</Message.Content>
									</Message>
								</Segment>
							</If>
							<If test={camposObrigatoriosPreenchidos}>
								<Segment attached secondary clearing>
									<ModalProdutos produtos={orcamento.produtos} cliente={orcamento.clienteId} onChange={(produtos) => this.handleChangeOrcamento(null, { name: 'produtos', value: produtos })} />
								</Segment>
								<Segment attached className='clean-scrollbar'>
									<Table compact striped selectable singleLine size='small'>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
												<Table.HeaderCell textAlign='left'>Descrição</Table.HeaderCell>
												<Table.HeaderCell textAlign='center'>Quantidade</Table.HeaderCell>
												<Table.HeaderCell textAlign='center'>Valor unitário (R$)</Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center'>Desconto (%)</Table.HeaderCell>
												<Table.HeaderCell textAlign='center'>Valor total (R$)</Table.HeaderCell>
											</Table.Row>
										</Table.Header>
										<Table.Body>
										{   
											isDefined(orcamento.produtos) && orcamento.produtos.length > 0 ? (
												orcamento.produtos.map((item) => {
													return <Table.Row key={item.codigo}>
																<Table.Cell textAlign='center'>{item.codigo}</Table.Cell>
																<Table.Cell textAlign='left'>{item.descricao}</Table.Cell>
																<Table.Cell textAlign='right'>{decimalFormat(item.quantidade, 3)}</Table.Cell>
																<Table.Cell textAlign='right'>{decimalFormat(item.valorUnitario, 2)}</Table.Cell>
                                                                <Table.Cell textAlign='right'>{decimalFormat(item.percentualDesconto, 2)}</Table.Cell>
																<Table.Cell textAlign='right'>{decimalFormat(item.valorTotal, 2)}</Table.Cell>
															</Table.Row>
												})
											) : (
												<Table.Row>
													<Table.Cell colSpan='6'>Nenhum produto adicionado.</Table.Cell>
												</Table.Row>
											)
										}
										</Table.Body>
									</Table>
								</Segment>
								<Segment clearing secondary attached>
									<Statistic.Group size='mini' widths='2'>
										<Statistic>
											<Statistic.Value>{orcamento.quantidadeItens}</Statistic.Value>
											<Statistic.Label>Produtos</Statistic.Label>
										</Statistic>
										<Statistic>
											<Statistic.Value>{decimalFormat(orcamento.valorTotal, 2)}</Statistic.Value>
											<Statistic.Label>Valor total (R$)</Statistic.Label>
										</Statistic>
									</Statistic.Group>
								</Segment>
							</If>
						</If>
						<Segment clearing attached='bottom'>
							<Button secondary type='button' floated='left' onClick={this.novoOrcamento}>
								<Icon name='refresh'/> Limpar
							</Button>
							<Button color='green' type='submit' floated='right' disabled={!orcamento.editado || orcamento.produtos.length === 0} onClick={() => this.salvarOrcamento()}>
								<Icon name='download'/> Salvar
							</Button>
						</Segment>
						
						<ConfirmSave open={confirmarSalvar}
									modalSize='tiny' 
									cancelButton='Cancelar'
									confirmButton='Confirmar e salvar'
									onCancel={() => this.setState({ confirmarSalvar: false })}
									onConfirm={this.salvarOrcamento}
									iconName='money'
									iconColor='green'
									iconSize='huge'
									header='Confirmar Forma de Pagamento'
									content={
										<div>
											<h3>Você confirma a forma de pagamento abaixo para o pedido?</h3>
											<Form>
												<Form.Group widths='equal'>
													<Form.Field>
														<label>Forma de pagamento</label>
														<Label size='large' className='fluid'>
														{ isDefined(_.find(formasPagamento, (item) => item.value === orcamento.formaPagamentoId)) ? _.find(formasPagamento, (item) => item.value === orcamento.formaPagamentoId).text : null }
														</Label>
													</Form.Field>
													<Form.Field>
														<label>Valor (R$)</label>
														<Label size='large' className='fluid text-align-right'>
															{decimalFormat(orcamento.valorTotal, 2)}
														</Label>
													</Form.Field>
												</Form.Group>
												<Form.Field required>
													<label>Senha de confirmação</label>
													<Input fluid autoFocus type='password' placeholder='Digite a sua senha' value={senhaConfirmacao} onChange={(e, { value }) => this.setState({ senhaConfirmacao: value })}/>
												</Form.Field>
											</Form>
										</div>
									}/>
                    </Tab.Pane> 
                )
            },
            { 
				menuItem: <Menu.Item key='orcamentos'>
							Orçamentos
						</Menu.Item>, 
                render: () => (
                    <Tab.Pane attached={false} className='no-pad-tab'>
						<Segment size='mini' clearing attached='top' secondary>
							<Form onSubmit={() => this.buscarOrcamentos()} size='tiny'>
								<Form.Group>
									<Form.Field width={4} control={Input} label='Código' name='codigo' value={ codigo } onChange={(e, {value}) => this.setState({ codigo: value.toUpperCase() })} />
									<If test={LocalStorageManager.getLoggedUser().isCliente}>
										<Form.Field width={12}>
											<label>Cliente</label>
											<Input disabled value={LocalStorageManager.getLoggedUser().nome} />
										</Form.Field>
									</If>
									<If test={!LocalStorageManager.getLoggedUser().isCliente}>
										<Form.Field width={12} control={Dropdown} label='Cliente'
												fluid search multiple selection selectOnBlur={false}
												placeholder='Nome do cliente' 
												noResultsMessage='Nenhum resultado encontrado' 
												value={cliente}
												options={clientes}
												loading={clientes === undefined}
												onChange={(e, { value }) => this.setState({ cliente: value })}/>
									</If>
								</Form.Group>
								<Form.Group widths='equal'>
									<Form.Field control={Input} label='Nota' name='nota' value={ nota } onChange={(e, {value}) => this.setState({ nota: value })} />
									<Form.Field control={DatePicker} required label='Data Inicial' selected={ dataInicial } maxDate={ dataFinal } onChange={ (dataInicial) => this.setState({ dataInicial }) } onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
									<Form.Field control={DatePicker} required label='Data Final' selected={ dataFinal } minDate={ dataInicial } onChange={ (dataFinal) => this.setState({ dataFinal }) } onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
									<Form.Button className='vertical-align-bottom' color='teal' content='Pesquisar' icon='search' compact fluid floated='right' size='medium' type='submit'/>
								</Form.Group>
							</Form>
						</Segment>
						<Segment size='mini' attached='bottom' className='clean-scrollbar'>
							<Table compact striped selectable singleLine size='small'>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
										<Table.HeaderCell textAlign='center'>Cliente</Table.HeaderCell>
										<Table.HeaderCell textAlign='center'>Data</Table.HeaderCell>
										<Table.HeaderCell textAlign='center'>Nota</Table.HeaderCell>
										<Table.HeaderCell textAlign='center'>Itens</Table.HeaderCell>
										<Table.HeaderCell textAlign='center'>Valor (R$)</Table.HeaderCell>
										<Table.HeaderCell textAlign='center'>Frete (R$)</Table.HeaderCell>
										<Table.HeaderCell textAlign='center'></Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								<Table.Body>
								{   
									isDefined(orcamentos) && orcamentos.registros > 0 ? (
										orcamentos.lista.map((item) => {
											return <Table.Row key={item.idt} style={{ cursor: 'pointer' }} onDoubleClick={() => this.props.history.push(this.props.match.url + '/' + item.idt)}>
														<Table.Cell textAlign='center'>{item.idt}</Table.Cell>
														<Table.Cell textAlign='left'>{item.nomeCliente}</Table.Cell>
														<Table.Cell textAlign='center'>{item.dataPedido}</Table.Cell>
														<Table.Cell textAlign='center'>{item.nota}</Table.Cell>
														<Table.Cell textAlign='center'>{item.quantidadeItens}</Table.Cell>
														<Table.Cell textAlign='right'>{decimalFormat(item.valorTotal, 2)}</Table.Cell>
														<Table.Cell textAlign='right'>{decimalFormat(item.valorFrete, 2)}</Table.Cell>
														<Table.Cell textAlign='right'>
															<Button size='mini' color='blue' title='Editar' content='Editar' icon='pencil' onClick={() => this.props.history.push(this.props.match.url + '/' + item.idt)}/>
														</Table.Cell>
													</Table.Row>
										})
									) : (
										<Table.Row>
											<Table.Cell colSpan='8'>Nenhum registro encontrado.</Table.Cell>
										</Table.Row>
									)
								}
								</Table.Body>
							</Table>
						</Segment>
                    </Tab.Pane> 
                )
            }
        ]

		return (
			<div>
				<Grid centered>
					<Grid.Column mobile={16} tablet={16} computer={16}>	
						<Segment.Group className='white-background'>
							<Segment>
								<Header>Orçamento</Header>
							</Segment>
							<Segment.Group>
								<Segment attached='top'>
									<Dimmer active={isLoading} inverted>
										<Loader inverted content='Carregando'/>
									</Dimmer>
									<Tab menu={{ pointing: true }} panes={panes} activeIndex={activeIndex} onTabChange={this.handleTabChange}/>
								</Segment>
								<Segment size='mini' clearing attached='bottom'>
									<Button negative content='Fechar' floated='left' icon='window close' onClick={() => this.props.history.push('/main')} />
								</Segment>
							</Segment.Group>
						</Segment.Group>
					</Grid.Column>
				</Grid>

				<Route path="/main/orcamentos/:idtOrcamento" component={DetalheOrcamento}/>
			</div>
        )
    }
}

export default withRouter(OrcamentoVenda);


// WEBPACK FOOTER //
// ./src/views/OrcamentoVenda/index.js